import {
  buildProps,
  makeNumericProp,
  makeStringProp,
  numericProp,
} from '@xzx-design/utils'

import type { ExtractPropTypes, PropType } from 'vue'
import type Sticky from './sticky.vue'
import type { StickyPosition, StickyScrollParams } from './types'

export const stickyProps = buildProps({
  zIndex: {
    type: numericProp,
  },
  position: makeStringProp<StickyPosition>('top'),
  container: {
    type: Object as PropType<Element | undefined>,
  },
  offsetTop: makeNumericProp(0),
  offsetBottom: makeNumericProp(0),
})

export type StickyProps = ExtractPropTypes<typeof stickyProps>
export type StickyInstance = InstanceType<typeof Sticky>

export const stickyEmits = {
  scroll: (params: StickyScrollParams) => params,
  change: (status: boolean) => status,
}

export type StickyEmits = ExtractPropTypes<typeof stickyEmits>
